/*!
 * groots by Globalia
 * Licensed under the WTFPL license
 *
 * Version: 1.5.0
 * Date: 2017-03-29
 */

// Declare Globals
window.groots = window.groots || {};
window.jquery = window.jQuery = window.$ = require('jquery'); // Will be removed

// Get SASS breakpoints
var sassToJs = require('sass-to-js');
window.groots.sassBreakpoints = sassToJs( document.querySelector('body'), { pseudoEl: ':before', cssProperty: 'content', debug: true } ); // eslint-disable-line

// Declare groots methods
window.groots.methods = {

    objectAssign : Object.assign || function (srcObj) { // eslint-disable-line
        for (var i = 1; i < arguments.length; i++) {
            for (var objProperty in arguments[i]) {
                if (Object.prototype.hasOwnProperty.call(arguments[i], objProperty)) srcObj[objProperty] = arguments[i][objProperty];
            }
        }
        return srcObj;
    },

    debounce : function (func, wait, immediate) {
        var timeout;
        return function() {
            var context = this, args = arguments;
            var later = function() {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    },

    // Check if viewport is larger than breakpoint (based on breakpoints defined in SASS)
    hasMinWidth : function (breakpoint) {
        if (typeof(breakpoint) === 'undefined') breakpoint = 'md';

        return window.innerWidth > parseInt(window.groots.sassBreakpoints[breakpoint], 10);
    },

    // Check if viewport is smaller than breakpoint (based on breakpoints defined in SASS)
    hasMaxWidth : function (breakpoint) {
        if (typeof(breakpoint) === 'undefined') breakpoint = 'md';

        return window.innerWidth <= parseInt(window.groots.sassBreakpoints[breakpoint], 10);
    },

    // Check if touch device
    isTouch : function () {
        return 'ontouchstart' in window ||
            window.DocumentTouch && document instanceof window.DocumentTouch ||
            navigator.maxTouchPoints > 0 ||
            window.navigator.msMaxTouchPoints > 0;
    },

    // Check if element is visible
    isVisible : function (el) {
        var windowWidth = window.innerWidth,
            windowHeight = window.innerHeight;
        if (windowWidth === null || windowHeight === null) return false;
        var rect = el.getBoundingClientRect();
        var elTop = rect.top;
        var elLeft = rect.left;
        var elWidth = rect.width;
        var elHeight = rect.height;
        return elTop < windowHeight && elTop + elHeight > 0 && elLeft < windowWidth && elLeft + elWidth > 0;
    },

    // Add or toggle an attribute value
    toggleAttributeValue : function (el, attribute, value, toggleClass) {
        if (toggleClass === undefined) var toggleClass = false;
        if (!el || !el.hasAttribute(attribute)) return;

        var values = el.getAttribute(attribute).split(' ');
        var existingIndex = values.indexOf(value);

        if (existingIndex >= 0) values.splice(existingIndex, 1);
        else values.push(value);
        if (toggleClass) el.classList.toggle('gr-' + value);

        el.setAttribute(attribute, values.join(' '));
    },

    // Remove attribute value(s)
    removeAttributeValue : function (el, attribute, value, removeClass) {
        if (removeClass === undefined) var removeClass = false;
        if (!el || !el.hasAttribute(attribute)) return;
        var values = el.getAttribute(attribute).split(' ');

        var valuesToRemove = value.split(' ');

        for (var i = valuesToRemove.length - 1; i >= 0; i--) {
            var existingIndex = values.indexOf(valuesToRemove[i]);
            if (existingIndex >= 0) values.splice(existingIndex, 1);
            if (removeClass) el.classList.remove('gr-' + valuesToRemove[i]);
        }

        el.setAttribute(attribute, values.join(' '));
    },

    // Check if element has attribute value
    hasAttributeValue : function (el, attribute, value) {
        if (!el || !el.hasAttribute(attribute)) return;

        var values = el.getAttribute(attribute).split(' ');
        var existingIndex = values.indexOf(value);

        if (existingIndex >= 0) {
            return true;
        } else {
            return false;
        };
    },

    // Wrap wrapper around nodes
    wrapAll : function (nodes, wrapper) {
        // Cache the current parent and previous sibling of the first node.
        var parent = nodes[0].parentNode;
        var previousSibling = nodes[0].previousSibling;

        // Place each node in wrapper.
        //  - If nodes is an array, we must increment the index we grab from
        //    after each loop.
        //  - If nodes is a NodeList, each node is automatically removed from
        //    the NodeList when it is removed from its parent with appendChild.
        for (var i = 0; nodes.length - i; wrapper.firstChild === nodes[0] && i++) {
            wrapper.appendChild(nodes[i]);
        }

        // Place the wrapper just after the cached previousSibling,
        // or if that is null, just before the first child.
        var nextSibling = previousSibling ? previousSibling.nextSibling : parent.firstChild;
        parent.insertBefore(wrapper, nextSibling);

        return wrapper;
    },

    // Easing function
    easeOutCubic : function (time) {
        return (--time) * time * time + 1;
    }
}
